// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* The actual timeline (the vertical ruler) */
.timeline {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
    border-radius: 20px;
}

.timeline-bg {
    background-color: var(--palette-timelineBg, #f0f0f0);
}

.timeline-img {
    max-height: 400px;
    max-width: 100%;
    border-radius: 20px;
}

.timeline-text {
    border-radius: 20px;
    width: fit-content;
    max-width: 100%;
    padding: 5px 10px;
    display: inline-block;
}

.timeline-text h2 {
    font-size: 1.3em;
}
.timeline-text h2 {
    font-size: 1.3em;
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
    content: '';
    position: absolute;
    width: 6px;
    background-color: #f3c23d;
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -3px;
}

/* Container around content */
.timeline-container {
    display: inline-flex;
    position: relative;
    width: 100%;
    justify-content: center;
    align-items: center;
}

/* Container around content */
.timeline-content-left {
    float: right;
    width: 50%;
    padding: 10px 15px;
    position: relative;
    display: flow;
    text-align: right;
}
/* Container around content */
.timeline-content-right {
    float: left;
    width: 50%;
    padding: 10px 15px;
    position: relative;
    display: flow;
    text-align: left;
}

/* The circles on the timeline */
.timeline-container::after {
    content: '';
    position: absolute;
    width: 25px;
    height: 25px;
    right: calc(50% - 12px);
    background-color: #025103;
    border: 4px solid #f3c23d;
    top: calc(50% - 15px);
    border-radius: 50%;
    z-index: 2;
}





`, "",{"version":3,"sources":["webpack://./src/css/timeline.css"],"names":[],"mappings":";AACA,6CAA6C;AAC7C;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA,6CAA6C;AAC7C;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,MAAM;IACN,SAAS;IACT,SAAS;IACT,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;AACA,6BAA6B;AAC7B;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd","sourcesContent":["\n/* The actual timeline (the vertical ruler) */\n.timeline {\n    position: relative;\n    max-width: 1200px;\n    margin: 0 auto;\n    border-radius: 20px;\n}\n\n.timeline-bg {\n    background-color: var(--palette-timelineBg, #f0f0f0);\n}\n\n.timeline-img {\n    max-height: 400px;\n    max-width: 100%;\n    border-radius: 20px;\n}\n\n.timeline-text {\n    border-radius: 20px;\n    width: fit-content;\n    max-width: 100%;\n    padding: 5px 10px;\n    display: inline-block;\n}\n\n.timeline-text h2 {\n    font-size: 1.3em;\n}\n.timeline-text h2 {\n    font-size: 1.3em;\n}\n\n/* The actual timeline (the vertical ruler) */\n.timeline::after {\n    content: '';\n    position: absolute;\n    width: 6px;\n    background-color: #f3c23d;\n    top: 0;\n    bottom: 0;\n    left: 50%;\n    margin-left: -3px;\n}\n\n/* Container around content */\n.timeline-container {\n    display: inline-flex;\n    position: relative;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Container around content */\n.timeline-content-left {\n    float: right;\n    width: 50%;\n    padding: 10px 15px;\n    position: relative;\n    display: flow;\n    text-align: right;\n}\n/* Container around content */\n.timeline-content-right {\n    float: left;\n    width: 50%;\n    padding: 10px 15px;\n    position: relative;\n    display: flow;\n    text-align: left;\n}\n\n/* The circles on the timeline */\n.timeline-container::after {\n    content: '';\n    position: absolute;\n    width: 25px;\n    height: 25px;\n    right: calc(50% - 12px);\n    background-color: #025103;\n    border: 4px solid #f3c23d;\n    top: calc(50% - 15px);\n    border-radius: 50%;\n    z-index: 2;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
